module.exports = __webpack_public_path__ + "img/logo-branco.12a7b411.png";